<script setup lang="ts">
import { CurrencyIcon } from '~/components/ui/currency-icon'
import { RATE_PLACEHOLDER } from '~/data/pages/rates/consts'

const props = defineProps<{
  rates: Record<string, { buy: number | null; sell: number | null }>
  isLoading?: boolean
}>()

const rateEntries = computed(() => Object.entries(props.rates))
</script>

<template>
  <div v-if="isLoading" class="w-full">
    <div class="flex flex-col justify-between gap-4 md:flex-row md:items-center md:gap-0">
      <div class="flex flex-wrap items-center gap-6">
        <div
          v-for="(group, index) in [
            [1, 2, 3],
            [4, 5]
          ]"
          :key="index"
          class="flex flex-col gap-4 md:flex-row"
        >
          <div v-for="item in group" :key="item" class="flex flex-col gap-4">
            <div class="flex items-center gap-2">
              <div class="h-6 w-6 rounded-full bg-gray-300" />
              <div class="h-4 w-10 rounded bg-gray-300" />
            </div>
            <div class="flex items-center gap-2">
              <div class="h-4 w-12 rounded bg-gray-300" />
              <div class="h-4 w-12 rounded bg-gray-300" />
            </div>
            <div class="flex items-center gap-2">
              <div class="h-4 w-12 rounded bg-gray-300" />
              <div class="h-4 w-12 rounded bg-gray-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div
      v-if="Object.keys(rates).length"
      class="flex flex-wrap items-center gap-6 md:flex-nowrap lg:justify-end"
    >
      <div
        v-for="[currency, rate] in rateEntries"
        :key="currency"
        class="flex w-[100px] flex-col gap-2"
      >
        <div class="flex items-center gap-2 font-semibold uppercase">
          <CurrencyIcon :code="currency" size="lg" />
          {{ currency }}
        </div>
        <div class="flex gap-4">
          <div>
            {{
              useCurrencyFormat(rate.buy, useGetCurrencyIdByCode(currency), false) ??
              RATE_PLACEHOLDER
            }}
          </div>
          <div>
            {{
              useCurrencyFormat(rate.sell, useGetCurrencyIdByCode(currency), false) ??
              RATE_PLACEHOLDER
            }}
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex items-center justify-between gap-4">
      {{ $t('widget.bank_page.rates_section.no_data') }}
    </div>
  </div>
</template>
